export class CommunicationLogEntry {
    constructor( public id: number,
        public title: string,
        public createdAt: Date,
        public domainIds: number[],
        public senderId: number,
        public senderName: string,
        public recipientId: number,
        public recipientName: string,
        public type: string,
        public subtype: string,
        public editable: boolean,
        public deletable: boolean,
        public incomming: boolean,
        public additionalAttributes: any ) { }

    public get referenceId(): string {
        return this.additionalAttributes?.referenceObjectIdentifier as string;
    }

    public get referenceType(): string {
        return this.additionalAttributes?.referenceObjectType as string;
    }

    public get linkUrl(): string {
        return this.additionalAttributes?.url as string;
    }

    public get isDocumentEntry(): boolean {
        return this.referenceType === 'DocumentMetadata';
    }

    public get titleMessageParams(): any[] {
        if ( !this.additionalAttributes ) {
            return [];
        }

        return [this.title, this.createdAt, this.senderName, this.recipientName, this.type, this.subtype, ...Object.values( this.additionalAttributes )];
    }
}